<template>
  <section class="style-section">
    <div class="title-guide">模块图标</div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 200px; height: 200px" :src="url1" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">功能</div>
    <div class="content-guide">
      本模块用于建立装配式结构（空心板、T梁、小箱梁）梁格模型，
      对比使用横向分布系数法的单梁模型，梁格模型计算结果更符合结构实际受力情况。
      梁格法特别适用于湿接缝不等宽的变宽装配式结构受力计算。
    </div>
    <div class="content-guide" style="font-weight: 600">
      本模块支持桥梁曲线布置、斜交布置以及梁体湿接缝不等宽扇形布置。
    </div>
    <div class="img-guide">
      <el-image
        class="size-img"
        style="width: 700px; height: 240px"
        :src="url20"
        :zoom-rate="1.2"
        :max-scale="1.5"
        :min-scale="0.2"
        :preview-src-list="srcList20"
        :initial-index="0"
        fit="cover"
      />
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">模块设计理念</div>
    <div class="content-guide">
      装配式结构设计时几乎都是采用标准图，每一次仅仅是更改湿接缝宽度和少量梁长，
      截面尺寸和钢束形状基本都是固定的。故可以考虑把标准图尺寸做成基本库。
      对于梁格模型，使用时只需要选择需要的标准库，定义一下梁板的数量和中距，那么截面尺寸、钢束尺寸参数就可以不用再输入了。
      剩下只需要定义梁长、桥面荷载，汽车荷载车道布置可以通过定义桥面横向各个分区的宽度来换算，这样就可以计算出模型所需的所有参数了。
      采用这样的方式，装配式结构的建模就像拼积木一样，可以大大减少建模参数输入量。
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">模块使用流程</div>
    <div class="content-guide">
      <div>本模块常规使用流程如下：</div>
      <li>选择标准——选择结构类型——选择采用的标准跨径</li>
      <li>定义孔跨布置——核查材料参数</li>
      <li>
        输入梁板片数，如果是曲线桥则引入路线文件（路线文件格式见详细说明）
      </li>
      <li>定义桥面布置</li>
      <li>选择汽车荷载，输入人群荷载</li>
      <li>输入桥面铺装荷载</li>
      <li>核查钢筋布置参数</li>
      <li>通过“中中距”或“边中距”来快速调整梁板顶面宽度，核查几何尺寸参数</li>
      <li>切换边梁、中梁，核查预应力钢束线型参数，确认孔道内钢绞线根数</li>
      <li>
        保存项目文件，然后导出mct文件，mct文件导入到Midas
        Civil后即可得到计算模型
      </li>
      <div>
        使用技巧：即使没有使用现有标准库参数，待第一次修改参数完成后项目文件存盘。
        下次使用时如果仅仅是梁板中距的区别，打开项目文件后仅需通过“中中距”或“边中距”来快速调整梁板顶面宽度，
        然后分别调整边梁、中梁预应力孔道内的钢绞线根数，就可以直接导出模型了。
      </div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image
          class="size-img"
          style="width: 700px; height: 420px"
          :src="url21"
          :zoom-rate="1.2"
          :max-scale="1.5"
          :min-scale="0.2"
          :preview-src-list="srcList21"
          :initial-index="0"
          fit="cover"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">标准选择</div>
    <div class="content-guide">
      本部分用于直接套用标准图尺寸参数和钢束参数，可以减少参数输入量，加快建模效率。
      使用时先选择数据库，程序会访问远程服务器并返回该标准下的结构类型，
      然后再选择结构类型，这时程序会继续访问远程服务器并返回该结构类型下的各种跨径对应参数。
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 210px; height: 130px" :src="url2" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">结构参数</div>
    <div class="content-guide">
      <li>
        跨径组合——多跨结构只能采用“+”和“-”符号进行连接，如“3-30”、“20+20”、“29.94+30+30+29.94”。
        多跨简支结构在进行上部构造验算时仅需按单跨计算，故跨径组合可以输入“1-29.96”。
      </li>
      <li>混凝土标号——选择上部构造混凝土采用的标号</li>
      <li>预应力钢材——选择上部构造采用的预应力钢束型号</li>
      <li>预应力管道——选择上部构造预应力钢束采用的管道类型</li>
      <li>
        跨径选用——选择某一个跨径后，下方的“一般构造尺寸”和“预应力布置”均会改为该标准对应各项参数。
        该功能仅在选择调整时启动，导出mct文件中“一般构造尺寸”和“预应力布置”对应参数与该选择无关，仅与下方表格内容参数有关。
      </li>
      <li>
        部位——通过选择，会重置“一般构造尺寸”和“预应力布置”参数，导出时按照选择部位组合尺寸参数（边梁参数还是中梁参数）。
        注意B7是边梁翼缘参数，切换到边梁时方可看到示意图。
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 370px; height: 130px" :src="url3" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">桥面及梁板布置</div>
    <div class="content-guide">
      <li>选择曲线时需要导入路线文件，路线文件格式详见相关说明。</li>
      <li>
        起点桩号——引入路线文件后，输入桥梁起点对应路线文件的桩号，程序将以该桩号为桥梁起点、结合路线文件计算桥梁各部位平面位置。
      </li>
      <li>梁板片数——横断面上梁板总数</li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 256px; height: 130px" :src="url4" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">桥面及梁板、横隔板布置</div>
    <div class="content-guide">
      <li>
        整幅、分幅——两者的区别主要在于模型中车道的计算和布置。选择整幅时，W6和W7如果输入0，
        则W5+W8作为一个行车道整体宽度按照规范中的对向行驶进行车道布置。车道布置考虑了偏载和居中两种工况。
      </li>
      <li>W1～W12——对应示意图各部位宽度。注意梁体的全宽必须大于桥面W1～W12的相加值，不然导出mct文件时会提示“桥面宽度超出梁板宽度”。</li>
      <li>荷载Q1～Q6——该荷载为除桥面铺装以外作用在桥面的其他荷载。</li>
      <div>Q1对应W1、W12宽度范围内的荷载（如人行道护栏、防撞护栏自重），</div>
      <div>Q2对应W2、W11宽度范围内的荷载(如人行道板自重)，</div>
      <div>
        Q3对应W3、W10宽度范围内的荷载（如非机动车道铺装调平层除开等厚部分自重），
      </div>
      <div>Q4对应W4、W9宽度范围内的荷载（如快慢车道分隔带自重），</div>
      <div>
        Q5对应W5、W8宽度范围内的荷载（如主行车道铺装调平层除开等厚部分自重），
      </div>
      <div>
        Q6对应W6、W7宽度范围内的荷载（如中央分隔带自重、分幅时右侧护栏自重）。
      </div>
      <div>特别注意荷载Q1～Q6的单位为kPa，即kN/m2。</div>
      <li>
        左边梁板距桥面左侧距离——该值为桥面系外侧护栏外边缘到边梁板外边缘距离，通常情况下该值取0，如遇到护栏内移的情况，根据实际情况填写。
      </li>
      <li>
        路线中心线到桥面左侧距离L3——本参数用于曲线桥时梁板的横向定位，便于计算梁体的精确位置。直线桥时本参数无意义，可填桥宽的一半。
      </li>
      <li>
        横隔板尺寸及间距。
      </li>
      <div>道数——横隔板的道数（包含端横隔板和中横隔板），修改该值后，应立即点击右侧“调整”按钮，刷新横隔板所有的参数。空心板该部分参数无意义，T梁或小箱梁最少填2道。</div>
      <div>平均高度——通常情况下端横隔板高度和中横隔板高度不一致，为了简化参数，这里统一为一种高度，一般填写中横隔板高度</div>
      <div>平均厚度——通常情况下端横隔板高度和中横隔板厚度不一致，为了简化参数，这里统一为一种厚度，一般填写中横隔板厚度</div>
      <div>标准间距——本参数仅用于刷新下方表格中间距参数，调整后需点击右侧“调整”按钮，方可刷新下表中间距参数。</div>
      <div>端横隔板距——端横隔板中心线到梁端部的水平距离。</div>
      <div>最下方的表格为中间横隔板相互间的间距参数，程序会按跨径中心线对称分布所有的中横隔板。因横隔板间距少于横隔板道数，故最后一行的间距参数无意义。</div>
      <li>梁端斜交角度——可以单独设置每一跨梁端的斜交角度，正交时角度输入0。</li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image
          class="size-img"
          style="width: 700px; height: 282px"
          :src="url5"
          :zoom-rate="1.2"
          :max-scale="1.5"
          :min-scale="0.2"
          :preview-src-list="srcList5"
          :initial-index="0"
          fit="cover"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">桥面活荷载</div>
    <div class="content-guide">
      <li>
        汽车荷载——可以选择公路-Ⅰ级和公路-Ⅱ级。城-A级等效公路-Ⅰ级，城-B级等效公路-Ⅱ级。
      </li>
      <li>
        人群荷载——考虑人行道宽度后的人群荷载，该值不考虑横向分布系数，不考虑人群荷载时输入0。
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 170px; height: 125px" :src="url6" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">桥面荷载</div>
    <div class="content-guide">
      <li>
        沥青混凝土层厚度——输入桥面沥青混凝土层的厚度。
        模型中该厚度乘以行车道宽度及密度（按24kN/m3取值）作为桥面荷载施加在梁体上。
        另外该厚度也用于温度梯度计算。桥梁没有该层时请输入数值0。
      </li>
      <li>
        水泥混凝土层厚度——输入结构宽度范围内水泥混凝土层的厚度。
        模型中该厚度乘以桥梁全宽及密度（按26kN/m3取值）作为桥面荷载施加在梁体上。
        如果沥青混凝土厚度为0，则程序按水泥混凝土铺装以该厚度作为温度梯度计算参数。
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 200px; height: 125px" :src="url7" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">钢筋布置</div>
    <div class="content-guide">
      按照设计图纸输入顶底板纵向普通钢筋数量、型号用于抗弯承载力验算。
      同时输入梁体端部横向箍筋数量、型号、间距，用于抗剪承载力验算。
      1个单箍需要输入的箍筋根数为2。
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 240px; height: 130px" :src="url8" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">一般构造尺寸</div>
    <div class="content-guide">
      <li>结合示意图，可以调整梁板纵向、跨中和端部的截面尺寸。</li>
      <li>
        纵向参数L4、L5用于多跨结构连续端，若孔跨布置为单孔，程序会将起点端参数L1～L3对称到终点端。
      </li>
      <li>多跨结构L4、L5参数不能为0，否则在导入Midas Civil时会出错。</li>
      <li>
        中中距——梁体之间的中心线水平距离。通过在弹窗中输入数值，程序会自动换算顶面宽度B2（相当于调整湿接缝宽度）参数值。
      </li>
      <li>
        边中距——边梁板底宽中心线到顶面外翼缘外侧的水平距离。通过在弹窗中输入数值，程序会自动换算顶面宽度B7（相当于调整外翼缘宽度）参数值。
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image
          class="size-img"
          style="width: 640px; height: 540px"
          :src="url9"
          :zoom-rate="1.2"
          :max-scale="1.5"
          :min-scale="0.2"
          :preview-src-list="srcList9"
          :initial-index="0"
          fit="fill"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">预应力布置</div>
    <div class="content-guide">
      <li>结合示意图，可以调整梁板预应力钢束形状参数。注意边梁和中梁是各自不同的参数，都需要设置。</li>
      <li>组数代表符合该钢束线型的孔道数，根数为单个孔道内钢绞线的根数。</li>
      <li>
        参数YH3、YH6、YL3、YL4、YR4用于多跨连续结构，若孔跨布置为单孔，程序会将简支端的参数对称到终点端。
      </li>
      <li>腹板钢束没有平弯时参数可以输入0。</li>
      <li>钢束类型可以通过点击“+”、“-”进行添加。</li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image
          class="size-img"
          style="width: 640px; height: 540px"
          :src="url10"
          :zoom-rate="1.2"
          :max-scale="1.5"
          :min-scale="0.2"
          :preview-src-list="srcList10"
          :initial-index="0"
          fit="cover"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">小箱梁顶板张拉段加厚</div>
    <div class="content-guide">
      <li>勾选“考虑局部加厚”后，程序将按示意图尺寸将局部单元的顶板厚度修改为输入值，加厚范围至图示位置内的单元端部。</li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 294px; height: 227px" :src="url11" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">预应力钢束特殊布置方式</div>
    <div class="content-guide">
      <li>勾选本选项后，多跨结构钢束将按以下方式布置：</li>
      <div>边跨——以简支端参数纵向对称布置，</div>
      <div>中跨——以连续端参数纵向对称布置。</div>      
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 166px; height: 58px" :src="url12" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">梁板墩台位置横向中心距</div>
    <div class="content-guide">
      <li>勾选“变宽桥梁”后，输出模型将考虑湿接缝变宽问题。湿接缝宽度将根据输入的边梁、中梁预制宽度和表格中的梁中距进行计算。</li>
      <li>桥面参数L3——同桥面布置中的参数L3，用于定位最左侧护栏至梁体左侧外边缘的水平距离。</li>
      <li>使用本功能后，导出的模型湿接缝将作为独立纵向单元存在，进行cdn验算时梁截面将不考虑湿接缝宽度范围的作用。</li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image
          class="size-img"
          style="width: 640px; height: 130px"
          :src="url13"
          :zoom-rate="1.2"
          :max-scale="1.5"
          :min-scale="0.2"
          :preview-src-list="srcList13"
          :initial-index="0"
          fit="cover"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <div style="height: 120px"></div>
</template>
<script>
export default {
  data() {
    return {
      url1: require("@/assets/png/unit2/1.png"),
      url2: require("@/assets/png/unit2/2.png"),
      url3: require("@/assets/png/unit2/3.png"),
      url4: require("@/assets/png/unit2/4.png"),
      url5: require("@/assets/png/unit2/5.png"),
      url6: require("@/assets/png/unit2/6.png"),
      url7: require("@/assets/png/unit2/7.png"),
      url8: require("@/assets/png/unit2/8.png"),
      url9: require("@/assets/png/unit2/9.png"),
      url10: require("@/assets/png/unit2/10.png"),
      url11: require("@/assets/png/unit2/11.png"),
      url12: require("@/assets/png/unit2/12.png"),
      url13: require("@/assets/png/unit2/13.png"),
      url20: require("@/assets/png/unit2/20.png"),
      url21: require("@/assets/png/unit2/19.png"),
      fit: "fill",
      srcList5: [require("@/assets/png/unit2/5.png")],
      srcList9: [require("@/assets/png/unit2/9.png")],
      srcList10: [require("@/assets/png/unit2/10.png")],
      srcList13: [require("@/assets/png/unit2/13.png")],
      srcList20: [
        require("@/assets/png/unit2/20.png"),
        require("@/assets/png/unit2/21.png"),
        require("@/assets/png/unit2/22.png"),
      ],
      srcList21: [require("@/assets/png/unit2/19.png")],
    };
  },
};
</script>
